import baseConfig from "@/config/baseConfig";
import sysConfig from "@/config/sysConfig.js";

export var checkRecordMoudle = function checkRecordMoudle(busiScope) {
  return sysConfig.$syscfg.K_Request("W0000117", busiScope);
};

export var submitEvaluating = function submitEvaluating(sysCust) {
  return sysConfig.$syscfg.K_Request("Y3000904", sysCust);
};

export var submitTask = function submitTask(param) {
  return sysConfig.$syscfg.K_Request("Y1001096", {
    B_SNO: param.B_SNO,
    BUSI_CODE: param.BUSI_CODE,
    HANDLE_CODE: param.HANDLE_CODE,

    APP_REMARK: param.APP_REMARK,
    OP_START_TIME: param.OP_START_TIME || "",
    "object.FLOW_VARS": param.FLOW_VARS || ""
  });
};

export var getHistoryBizs = function getHistoryBizs(param) {
  return sysConfig.$syscfg.K_Request("F0000036", param);
};

export var synEvaluatingInfo = function synEvaluatingInfo(param) {
  return sysConfig.$syscfg.K_Request("YG000904", param);
};

export var openSynEvaluatingInfo = function openSynEvaluatingInfo(param) {
  return sysConfig.$syscfg.K_Request("Y1190109", param);
};

export var getFlowDic = function getFlowDic(dic) {
  if (dic == "01") {
    return "受理";
  } else if (dic == "02") {
    return "预受理";
  } else if (dic == "03") {
    return "待审批";
  } else if (dic == "04") {
    return "审批中";
  } else if (dic == "05") {
    return "待审核";
  } else if (dic == "06") {
    return "审核中";
  } else if (dic == "07") {
    return "待复核";
  } else if (dic == "08") {
    return "复核中";
  } else if (dic == "09") {
    return "待差错处理";
  } else if (dic == "10") {
    return "差错处理中";
  } else if (dic == "11") {
    return "驳回";
  } else if (dic == "12") {
    return "预受理驳回";
  } else if (dic == "13") {
    return "完成";
  }
};

export var openView = function openView(params) {
  try {
    if (baseConfig.$basecfg.platform == "vtm") {
      if (!(_.isObject(params) && params.screenType && params.screenType == "carsouleImg")) {
        consoleLog("下屏幕指令--", {
          screenType: params.screenType,
          orderType: params.orderType,
          deviceType: params.deviceType
        });
      }

      if (popupwin) {
        popupwin.postMessage(params, window.location.protocol + "//" + window.location.host);
      } else {
        popupwin = window.open("second.html", "videoRecord", "height=1080,width=1920,top=0,left=1300,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no,fullscreen=yes,channelmode=yes,titlebar=no");
        setTimeout(function () {
          popupwin.postMessage(params, window.location.protocol + "//" + window.location.host);
        }, 2000);
      }
    }
  } catch (error) {
    consoleLog("下屏幕往上屏幕发送消息失败，原因：" + error + "丢失数据：", params);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/record-service.js
// module id = 954
// module chunks = 2